import { useNavigate } from 'react-router-dom';
import { Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ReportIcon from '@mui/icons-material/Report';
import { Operation } from 'src/networkRequest/operationsService';

const OperationMenu = ({ operation }: { operation: Operation }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <List
      sx={{
        p: 0,
        backgroundColor: theme.palette.blueGrey[50],
        borderRadius: '10px',
      }}
    >
      <ListItem>
        <ListItemButton
          onClick={() => navigate('activities', { state: { operationId: operation.id } })}
          sx={{ p: 0 }}
        >
          <ListItemIcon sx={{ mr: '11px', minWidth: 0 }}>
            <DescriptionIcon />
          </ListItemIcon>
          <ListItemText primary='Activity' sx={{ color: theme.palette.text.primary }} />
          <ListItemIcon sx={{ minWidth: 0 }}>
            <NavigateNextIcon />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>

      <Divider sx={{ ml: '16px', mr: '16px' }} />

      <ListItem>
        <ListItemButton
          onClick={() => navigate('incidents', { state: { operationId: operation.id } })}
          sx={{ p: 0 }}
        >
          <ListItemIcon sx={{ mr: '11px', minWidth: 0 }}>
            <ReportIcon />
          </ListItemIcon>
          <ListItemText primary='Incidents' sx={{ color: theme.palette.text.primary }} />
          <ListItemIcon sx={{ minWidth: 0 }}>
            <NavigateNextIcon />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    </List>
  );
}

export default OperationMenu;